import React, { useEffect, useRef, useState } from "react";
import Layout from "@components/layout/Layout";
import * as P from "@components/customizing/print/Print.styles";
import { SeoMeta } from "@/utils/seo/SeoMeta";
import { useTabStickyHandler } from "@hook/customizing/print/useTabStickyHandler";
import { useGetEventList } from "@hook/event/useEventListQuery";
import { connect } from "react-redux";
import styled from "styled-components";
import { successAlert } from "@common/alert";
// ✅ Next.js Router 사용
import { useRouter } from "next/router";

const HtmlWrapper = styled.div`
  max-width: 100%;
  display: flex;
  justify-content: center;

  & figure {
    max-width: 100%;
  }
`;

const Event = ({ dummyList }) => {
  const tabHeaderRef = useRef(null);
  const { isSticky } = useTabStickyHandler(tabHeaderRef);

  const router = useRouter();
  const { code } = router.query; // /event/[code] 에서 code

  const [activeIndex, setActiveIndex] = useState(0);
  const eventList = dummyList?.event?.data || [];

  const truncate = (text, maxLength = 10) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "...": text;
  };

  // ✅ URL의 code 기준으로 활성 탭 맞추기
  useEffect(() => {
    if (!eventList.length) return;

    if (code) {
      const foundIndex = eventList.findIndex((item) => item.code === code);
      if (foundIndex !== -1) {
        setActiveIndex(foundIndex);
        return;
      }
    }

    // code가 없거나 매칭되는 게 없으면 첫 번째 탭
    setActiveIndex(0);
  }, [code, eventList]);

  // ✅ 실제로 사용할 code (API용)
  const selectedCode =
    eventList.length === 1
      ? eventList[0].code
      : eventList[activeIndex]?.code || eventList[0]?.code;

  // 이벤트 상세 데이터
  const { data: eventDetail, isLoading } = useGetEventList(selectedCode);

  // ✅ 탭 변경 시 URL을 /event/코드 형태로 변경
  const onChangeMainTab = (index) => {
    setActiveIndex(index);
    const item = eventList[index];
    if (!item) return;

    router.push(`/event/${item.code}`, undefined, { shallow: true });
  };

  // ✅ SEO용 메타 값 (이벤트별로 동적 처리)
  const pageTitle =
    eventDetail?.seoTitle ||
    eventDetail?.title ||
    SeoMeta.event?.title;

  const pageDesc =
    eventDetail?.seoDescription ||
    SeoMeta.event?.description;

  const pageKeyword =
    eventDetail?.seoKeywords ||
    SeoMeta.event?.keywords;

  return (
    <Layout
      parent="홈"
      sub="이벤트"
      pageTitle={pageTitle}
      pageDesc={pageDesc}
      pageKeyword={pageKeyword}
    >
      <div>
        {/* 탭 헤더 */}
        {eventList.length > 1 ? (
          <P.TabContainer ref={tabHeaderRef} isSticky={isSticky}>
            <P.TabHeader>
              {eventList.map((item, index) => (
                <P.TabItem
                  key={item.code}
                  active={index === activeIndex}
                  onClick={() => onChangeMainTab(index)}
                >
                  {truncate(item.title)}
                </P.TabItem>
              ))}
            </P.TabHeader>
          </P.TabContainer>
        ) : (
          <div className="no-event" />
        )}

        {/* 상세 영역 */}
        <div className="container">
          {isLoading ? (
            <p>로딩 중...</p>
          ) : eventDetail ? (
            <>
              <div className="pb-30 d-flex align-items-center justify-content-between">
                {/* 제목 표시 */}
                <h2 className={"mt-20 mb-20"}>{eventDetail.title}</h2>
                {/* 공유 */}
                <a
                  aria-label="Share"
                  className="action-btn hover-up"
                  onClick={() =>
                    navigator.clipboard
                      .writeText(globalThis.location.href)
                      .then(() => successAlert("복사되었습니다."))
                  }
                >
                  <i
                    className="fi-rs-share"
                    style={{ fontSize: "20px" }}
                  />
                </a>
              </div>

              {/* 내용 표시 */}
              <HtmlWrapper>
                <div
                  className="ck-content"
                  dangerouslySetInnerHTML={{ __html: eventDetail.content }}
                />
              </HtmlWrapper>
            </>
          ) : null}
        </div>
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  dummyList: state.dummyList,
});

export default connect(mapStateToProps)(Event);
